/**
 * Style unique des pastilles (statuts, rôles…) de toutes les pages : centrées
 * verticalement dans leur cellule, sans retour à la ligne. line-height = font-size
 * pour qu'aucun interligne ne décale le texte dans la pastille.
 *
 * `extra` surcharge le style ; passer `fontSize` y recale aussi `lineHeight`.
 * Pastille au fil d'un texte (pas seule dans une cellule) : `{ display: 'inline-block' }`.
 */
export const pill = (bg, color, { fontSize = '0.78rem', ...extra } = {}) => ({
  display: 'block',
  background: bg,
  color,
  padding: '4px 10px',
  borderRadius: '99px',
  fontSize,
  lineHeight: fontSize,
  fontWeight: 600,
  textWrap: 'nowrap',
  whiteSpace: 'nowrap',
  textAlign: 'center',
  verticalAlign: 'middle',
  ...extra,
});
